import { Flex, Spin } from 'antd'
import React from 'react'

export const SuspenseLoading: React.FC = () => {
  return <Flex align="center" justify="center" className="w-full h-full"><Spin size="large" /></Flex>
}